module.exports = __webpack_public_path__ + "img/clock.6cab66c1.png";